import { useEffect, useState } from 'react';
import { Button, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { getExternalMemberLoginUrl } from '@/config/externalPortals';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refreshSession } = useAuth();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    void refreshSession().then((authenticated) => {
      if (authenticated) {
        navigate('/', { replace: true });
      } else {
        setFailed(true);
      }
    });
  }, [navigate, refreshSession]);

  if (failed) {
    return (
      <Result
        status="warning"
        title="無法建立 CRM 安全工作階段"
        subTitle="請重新由中央會員入口登入；CRM 不接受網址中的 access token。"
        extra={(
          <Button type="primary" href={getExternalMemberLoginUrl(window.location.origin + '/')}>
            重新登入
          </Button>
        )}
      />
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Spin size="large" tip="正在確認伺服器端 SSO 工作階段..." />
    </div>
  );
}
